export default ['image/jpeg', 'image/png'];
